import { Component, OnInit } from '@angular/core';
import { DialogService } from "../dialog";
import { DialogComponent } from "../dialog/dialog.component";
import { InPurchasesService } from '../../services/inventory/in-purchases.service';
import { DataService } from '../../services/data.service';
import {CaMasterService} from '../../../shared/services/accounts/ca-master.service'
export interface ConfirmModelUnpost {
  title: string;
  message: string;
  data:number;
}                               
@Component({
  selector: 'app-unpostsales',
  templateUrl: './unpostsales.component.html',
  styleUrls: ['./unpostsales.component.css']
})
export class UnpostsalesComponent extends DialogComponent<ConfirmModelUnpost, boolean> implements ConfirmModelUnpost,OnInit {
  title: string;
  message: string;
  data:number;
  loading: boolean = false;
  result: any = { item: [], result: false };;
  rtnData: any;
  PostedDate :Date;
  VoucherType:number;
  saveDisable:boolean=false;
  isLoaded:boolean = true;
  model = [{
      Id : 0,
      Description : "",
      Amount : 0,
      ReferenceNo : "",
      VoucherType : 0,
      LocId : 0
  }]
  constructor(dialogService: DialogService, private ds: DataService,private ca: CaMasterService) { 
    super(dialogService);
  }

  ngOnInit() {
    this.PostedDate=new Date;
    this.VoucherType=this.data;
     this.saveDisable=false;
     this.clear()
  }
getPostedSales(){
  this.isLoaded = false;
  var filter:any={
    "Ddate": this.PostedDate,
    "LocationId": this.ds.Settings.LocationId
  }
  this.ca.Get_postedSalesDetails(filter).subscribe(res=>{
    if(res.Success){
      this.model=res.data;
      this.saveDisable=true;
      this.isLoaded = true;
    }
    else{
      alert(res.error.UserMsg);
      this.saveDisable=false;
      this.isLoaded = true;
    }
  })
}
unpost(){
  if(this.model.length>0){
  var t=confirm("Do you want to unpost this sales?")
  if(t){
    this.isLoaded = false;
    if(this.model.length>0){
      for(let i of this.model){
        i.VoucherType=this.VoucherType;
      }
    }
    this.ca.UnPost_Sales(this.model).subscribe(res=>{
      if(res.Success){
        alert(res.Message)
        this.saveDisable=false;
        this.clear();
      }
      else{
        alert(res.error.UserMsg)
        this.saveDisable=true;
        this.isLoaded = true;
      }
    })
  }
  else{
    this.saveDisable=true;
    this.isLoaded = true;
  }
}
  else{
    alert("List empty")
    this.saveDisable=false;
    this.isLoaded = true;
  }
}
clear(){
  this.model=[];
  this.isLoaded = true;
}
closeModal(id: string) {
  this.close();
}
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/unpostsales/unpostsales.component.ts